<tui-root tuiTheme="light">
  <app-network-status-banner></app-network-status-banner>

  @if (appStore.loading()) {
  <progress max="100" tuiProgressBar size="xs"
    class="absolute top-0 left-0 w-full h-1 text-reverb-primary z-50"></progress>
  }
  <app-navigation> </app-navigation>

  <!-- Session Timeout Warning -->
  <app-session-timeout-warning></app-session-timeout-warning>
  <app-visual-report-upgrade />
</tui-root>